module.exports = __webpack_public_path__ + "img/jengibre.99660c5d.svg";